import React from 'react';

export const ProfileBigSize = () => {
    return (
        <svg
            width="100"
            height="100"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="20" height="20" rx="10" fill="#F4F4F8" />
            <g clipPath="url(#clip0_3087_33671)">
                <path
                    d="M10 4.375C8.53514 4.375 7.33333 5.5768 7.33333 7.04167C7.33333 8.50653 8.53514 9.70833 10 9.70833C11.4649 9.70833 12.6667 8.50653 12.6667 7.04167C12.6667 5.5768 11.4649 4.375 10 4.375ZM10 5.70833C10.7443 5.70833 11.3333 6.29739 11.3333 7.04167C11.3333 7.78594 10.7443 8.375 10 8.375C9.25572 8.375 8.66667 7.78594 8.66667 7.04167C8.66667 6.29739 9.25573 5.70833 10 5.70833ZM10 10.7083C8.8367 10.7083 7.45811 10.9815 6.29948 11.4388C5.72016 11.6674 5.19647 11.939 4.77734 12.2878C4.35822 12.6365 4 13.1079 4 13.7083V15.375H16V14.7083V13.7083C16 13.1079 15.6418 12.6365 15.2227 12.2878C14.8035 11.939 14.2798 11.6674 13.7005 11.4388C12.5419 10.9815 11.1633 10.7083 10 10.7083ZM10 12.0417C10.9427 12.0417 12.2307 12.291 13.2122 12.6784C13.703 12.8721 14.118 13.103 14.3698 13.3125C14.6216 13.522 14.6667 13.6647 14.6667 13.7083V14.0417H5.33333V13.7083C5.33333 13.6647 5.37839 13.522 5.63021 13.3125C5.88203 13.103 6.29699 12.8721 6.78776 12.6784C7.7693 12.291 9.0573 12.0417 10 12.0417Z"
                    fill="#C1C4C9"
                />
            </g>
            <defs>
                <clipPath id="clip0_3087_33671">
                    <rect width="12" height="12" fill="white" transform="translate(4 4)" />
                </clipPath>
            </defs>
        </svg>
    );
};
